import { type PathParams } from "@constellation-academy/epic-ui";
import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type limitedCartDiscountEditScreen_LimitedCartDiscountQuery } from "@relay/limitedCartDiscountEditScreen_LimitedCartDiscountQuery.graphql";
import { QUERY } from "./limited-cart-discount-edit.graphql";
import { LimitedCartDiscountForm } from "./parts/limited-cart-discount-form";
import { Card } from "../../components/card";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";
import { type LimitedCartDiscountsPath } from "../limited-cart-discounts";

export const EditLimitedCartDiscountScreen = () => {
	const { t } = useTranslation("common");
	const { cartDiscountId } = useParams<PathParams<typeof LimitedCartDiscountsPath>>();

	const query = useLazyLoadQuery<limitedCartDiscountEditScreen_LimitedCartDiscountQuery>(QUERY, {
		id: cartDiscountId!,
		skip: !cartDiscountId,
	});

	const canReadAndModify = useHasPermissions([
		"UserInAccountPermission_LimitedCartDiscountAdmin_Read",
		"UserInAccountPermission_LimitedCartDiscountAdmin_Modify",
	]);

	if (!canReadAndModify) {
		return <NoAccess />;
	}

	return query.node ? (
		<Suspense fallback={<ProgressSpinner />}>
			<div className="p-4">
				<Card>
					<h2 className="mb-3 text-center">
						{t("cartDiscount.editTitle", { title: query.node.title })}
					</h2>
					<LimitedCartDiscountForm limitedCartDiscountFragmentRef={query.node} />
				</Card>
			</div>
		</Suspense>
	) : (
		<h4>{t("cartDiscount.loadError")}</h4>
	);
};
